/* Share a farmers market (or a city/state list): phone share sheet, text, email, social sites, copy link,
   "I'm going" with a day, and add-to-calendar (Google link or .ics for Apple/Outlook).
   Markup: <button data-fm-share data-title data-url data-place [data-days="Sat,Sun"] [data-months="4,5"]
            [data-hours="9am-1pm"] [data-address] [data-image] [data-kind="market"|"list"]> */
(function () {
  'use strict';
  var btn = document.querySelector('[data-fm-share]');
  if (!btn) return;
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DOW_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var d = btn.dataset;
  var title = d.title || document.title;
  var pageUrl = d.url || location.href.split('#')[0].split('?')[0];
  var isMarket = d.kind !== 'list';
  var days = (d.days || '').split(',').filter(Boolean);
  var months = (d.months || '').split(',').filter(Boolean).map(Number);
  var picked = null;                                   // Date the visitor says they're going, or null

  // ------------------------------------------------------------------ helpers
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function enc(s) { return encodeURIComponent(s); }
  function tagged(source) {                            // UTM-tagged link so shares show up in analytics
    return pageUrl + (pageUrl.indexOf('?') === -1 ? '?' : '&') + 'utm_source=' + enc(source) + '&utm_medium=share&utm_campaign=fm_share';
  }
  function dayLabel(dt) { return DOW[dt.getDay()] + ', ' + MON[dt.getMonth()] + ' ' + dt.getDate(); }
  function ymd(dt) { return dt.getFullYear() + String(dt.getMonth() + 1).padStart(2, '0') + String(dt.getDate()).padStart(2, '0'); }

  function upcoming(n) {                               // next market days within 3 weeks, in season
    var out = [], t = new Date();
    t.setHours(12, 0, 0, 0);
    for (var i = 0; i < 21 && out.length < n; i++) {
      var dt = new Date(t.getFullYear(), t.getMonth(), t.getDate() + i, 12);
      if (days.indexOf(DOW[dt.getDay()]) !== -1 && (!months.length || months.indexOf(dt.getMonth() + 1) !== -1)) out.push(dt);
    }
    return out;
  }

  // "9am-1pm", "8:00 am to 12:00 pm", "8am-noon" -> [[9,0],[13,0]] or null
  function parseHours(s) {
    var m = /(\d{1,2})(?::(\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?\s*(?:-|–|—|to)\s*(\d{1,2}|noon)(?::(\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?/i.exec(s || '');
    if (!m) return null;
    function h24(h, ap) {
      h = Number(h);
      if (!ap) return h;
      ap = ap.charAt(0).toLowerCase();
      if (h === 12) return ap === 'a' ? 0 : 12;
      return ap === 'p' ? h + 12 : h;
    }
    if (!m[3] && !m[6] && !/noon/i.test(m[4])) return null;   // "9-1" with no am/pm: too ambiguous
    var endNoon = /noon/i.test(m[4]);
    var eap = endNoon ? 'pm' : m[6];
    if (!eap) eap = h24(m[4], 'am') > h24(m[1], m[3]) ? 'am' : 'pm';   // "9am-1" -> 1pm
    var eh = endNoon ? 12 : h24(m[4], eap), em = endNoon ? 0 : Number(m[5] || 0);
    var sap = m[3];
    if (!sap) {                                       // "4-7pm" -> 4pm, "9-1pm" -> 9am, "10-12pm" -> 10am
      var s12 = Number(m[1]), e12 = endNoon ? 12 : Number(m[4]);
      sap = /^a/i.test(eap) || e12 === 12 || s12 > e12 ? 'am' : 'pm';
    }
    var sh = h24(m[1], sap), sm = Number(m[2] || 0);
    if (sh > 23 || eh > 23 || sm > 59 || em > 59 || eh * 60 + em <= sh * 60 + sm) return null;
    return [[sh, sm], [eh, em]];
  }
  var hours = parseHours(d.hours);
  function hm(x) { return String(x[0]).padStart(2, '0') + String(x[1]).padStart(2, '0') + '00'; }

  function message(withUrl, source) {
    var link = withUrl ? ' ' + tagged(source) : '';
    if (picked) {
      return "I'm going to " + title + ' on ' + DOW_LONG[picked.getDay()] + ', ' + MON[picked.getMonth()] + ' ' + picked.getDate()
        + (d.hours ? ' (' + d.hours + ')' : '') + '. Want to come?' + link;
    }
    return (isMarket ? 'Check out ' + title + (d.place ? ' in ' + d.place : '') : title) + link;
  }

  var targets = [
    { id: 'sms', label: 'Text message', icon: 'chat', href: function () { return 'sms:?&body=' + enc(message(true, 'sms')); } },
    { id: 'email', label: 'Email', icon: 'mail', href: function () {
      return 'mailto:?subject=' + enc(picked ? "I'm going to " + title : title) + '&body=' + enc(message(true, 'email')); } },
    { id: 'whatsapp', label: 'WhatsApp', href: function () { return 'https://wa.me/?text=' + enc(message(true, 'whatsapp')); } },
    { id: 'facebook', label: 'Facebook', href: function () { return 'https://www.facebook.com/sharer/sharer.php?u=' + enc(tagged('facebook')); } },
    { id: 'x', label: 'X', href: function () { return 'https://x.com/intent/tweet?text=' + enc(message(false)) + '&url=' + enc(tagged('x')); } },
    { id: 'nextdoor', label: 'Nextdoor', href: function () { return 'https://nextdoor.com/sharekit/?source=vanillagoods&body=' + enc(message(true, 'nextdoor')); } },
    { id: 'threads', label: 'Threads', href: function () { return 'https://www.threads.net/intent/post?text=' + enc(message(true, 'threads')); } },
    { id: 'bluesky', label: 'Bluesky', href: function () { return 'https://bsky.app/intent/compose?text=' + enc(message(true, 'bluesky')); } },
    { id: 'pinterest', label: 'Pinterest', href: function () {
      return 'https://pinterest.com/pin/create/button/?url=' + enc(tagged('pinterest')) + '&description=' + enc(message(false)) + (d.image ? '&media=' + enc(d.image) : ''); } },
    { id: 'linkedin', label: 'LinkedIn', href: function () { return 'https://www.linkedin.com/sharing/share-offsite/?url=' + enc(tagged('linkedin')); } },
    { id: 'reddit', label: 'Reddit', href: function () { return 'https://www.reddit.com/submit?url=' + enc(tagged('reddit')) + '&title=' + enc(message(false)); } },
    { id: 'telegram', label: 'Telegram', href: function () { return 'https://t.me/share/url?url=' + enc(tagged('telegram')) + '&text=' + enc(message(false)); } }
  ];
  var ICON = {
    chat: '<path d="M4 5h16v11H9l-5 4z"/>',
    mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/>',
    link: '<path d="M10 14a4 4 0 0 0 6 0l3-3a4 4 0 0 0-6-6l-1 1M14 10a4 4 0 0 0-6 0l-3 3a4 4 0 0 0 6 6l1-1"/>',
    cal: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>',
    share: '<path d="M12 3v12M7 8l5-5 5 5M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/>'
  };
  function svg(name) { return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + ICON[name] + '</svg>'; }

  function track(method) {
    if (typeof window.gtag === 'function') window.gtag('event', 'share', { method: method, content_type: isMarket ? 'farmers_market' : 'farmers_market_list', item_id: pageUrl });
  }

  // ------------------------------------------------------------------ panel
  var panel = document.createElement('div');
  panel.className = 'fm-sharep';
  panel.hidden = true;
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Share ' + title);
  var dates = isMarket ? upcoming(3) : [];
  panel.innerHTML =
    '<div class="fm-sharep__top"><strong>' + (isMarket ? 'Share this market' : 'Share this list') + '</strong>'
    + '<button type="button" class="fm-sharep__x" data-x aria-label="Close">&times;</button></div>'
    + (isMarket ? '<div class="fm-sharep__going"><span class="fm-sharep__label">Tell friends you\'re going</span><div class="fm-sharep__days">'
      + dates.map(function (dt, i) { return '<button type="button" class="fm-sharep__day" aria-pressed="false" data-day="' + i + '">' + esc(i === 0 && ymd(dt) === ymd(new Date()) ? 'Today' : dayLabel(dt)) + '</button>'; }).join('')
      + '<label class="fm-sharep__pick"><span class="visually-hidden">Pick a day</span><input type="date" data-pick></label></div>'
      + '<p class="fm-sharep__preview" data-preview></p></div>' : '')
    + (navigator.share ? '<button type="button" class="fm-sharep__native" data-native>' + svg('share') + 'Share with apps on this device</button>' : '')
    + '<div class="fm-sharep__grid">' + targets.map(function (t) {
      return '<a class="fm-sharep__t" data-t="' + t.id + '" target="_blank" rel="noopener">' + (t.icon ? svg(t.icon) : '') + esc(t.label) + '</a>';
    }).join('') + '</div>'
    + '<button type="button" class="fm-sharep__copy" data-copy>' + svg('link') + '<span>Copy link</span></button>'
    + (isMarket ? '<div class="fm-sharep__cal" data-cal hidden><span class="fm-sharep__label">Add it to your calendar</span>'
      + '<a class="fm-sharep__t" data-gcal target="_blank" rel="noopener">' + svg('cal') + 'Google Calendar</a>'
      + '<button type="button" class="fm-sharep__t" data-ics>' + svg('cal') + 'Apple / Outlook (.ics)</button></div>' : '');
  btn.parentNode.appendChild(panel);
  var pick = panel.querySelector('[data-pick]');
  if (pick) {
    var today = new Date();
    pick.min = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
  }

  function refresh() {
    Array.prototype.forEach.call(panel.querySelectorAll('[data-t]'), function (a) {
      var t = targets.filter(function (x) { return x.id === a.getAttribute('data-t'); })[0];
      a.href = t.href();
      if (t.id === 'sms' || t.id === 'email') a.removeAttribute('target');
    });
    var pv = panel.querySelector('[data-preview]');
    if (pv) pv.textContent = picked ? message(false) : 'Pick a day to share "I\'m going" and add it to your calendar.';
    var cal = panel.querySelector('[data-cal]');
    if (cal) {
      cal.hidden = !picked;
      if (picked) panel.querySelector('[data-gcal]').href = gcal();
    }
  }

  function when() {                                    // [start, end] strings for calendars
    if (hours) return [ymd(picked) + 'T' + hm(hours[0]), ymd(picked) + 'T' + hm(hours[1])];
    var next = new Date(picked.getFullYear(), picked.getMonth(), picked.getDate() + 1, 12);
    return [ymd(picked), ymd(next)];
  }
  function details() { return (d.hours ? 'Hours as listed: ' + d.hours + '. ' : '') + 'Please confirm with the market before you go. ' + tagged('calendar'); }
  function gcal() {
    var w = when();
    return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + enc(title) + '&dates=' + w[0] + '/' + w[1]
      + '&details=' + enc(details()) + (d.address ? '&location=' + enc(d.address) : '');
  }
  function icsText(s) { return String(s).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
  function ics() {
    var w = when(), allDay = !hours;
    var stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
    var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//VanillaGoods//Farmers Markets//EN', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT',
      'UID:' + w[0] + '-' + Math.random().toString(36).slice(2) + '@vanillagoods.com', 'DTSTAMP:' + stamp,
      allDay ? 'DTSTART;VALUE=DATE:' + w[0] : 'DTSTART:' + w[0], allDay ? 'DTEND;VALUE=DATE:' + w[1] : 'DTEND:' + w[1],
      'SUMMARY:' + icsText(title), 'DESCRIPTION:' + icsText(details()), 'URL:' + tagged('calendar')];
    if (d.address) lines.push('LOCATION:' + icsText(d.address));
    lines.push('END:VEVENT', 'END:VCALENDAR');
    return lines.join('\r\n') + '\r\n';
  }

  function setPicked(dt, fromChip) {
    picked = dt;
    Array.prototype.forEach.call(panel.querySelectorAll('.fm-sharep__day'), function (b) {
      b.setAttribute('aria-pressed', String(!!fromChip && b === fromChip));
    });
    if (pick && fromChip) pick.value = '';
    refresh();
  }

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    refresh();
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('fm-share-open');
    var first = panel.querySelector('.fm-sharep__day, [data-native], .fm-sharep__t');
    if (first) first.focus();
  }
  function close() {
    if (panel.hidden) return;
    panel.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('fm-share-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  btn.setAttribute('aria-haspopup', 'dialog');
  btn.setAttribute('aria-expanded', 'false');
  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    if (panel.hidden) open(); else close();
  });
  document.addEventListener('click', function (e) { if (!panel.hidden && !panel.contains(e.target)) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  panel.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var el;
    if ((el = t.closest('[data-x]'))) return close();
    if ((el = t.closest('.fm-sharep__day'))) {
      var dt = dates[Number(el.getAttribute('data-day'))];
      return setPicked(el.getAttribute('aria-pressed') === 'true' ? null : dt, el.getAttribute('aria-pressed') === 'true' ? null : el);
    }
    if ((el = t.closest('[data-t]'))) return track(el.getAttribute('data-t'));
    if ((el = t.closest('[data-gcal]'))) return track('google_calendar');
    if ((el = t.closest('[data-native]'))) {
      track('native');
      navigator.share({ title: title, text: message(false), url: tagged('native') }).catch(function () { /* cancelled */ });
      return;
    }
    if ((el = t.closest('[data-copy]'))) {
      var label = el.querySelector('span');
      var done = function () { label.textContent = 'Link copied'; setTimeout(function () { label.textContent = 'Copy link'; }, 2000); };
      track('copy_link');
      var link = tagged('copy');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(done, function () { window.prompt('Copy this link:', link); });
      } else {
        window.prompt('Copy this link:', link);
      }
      return;
    }
    if ((el = t.closest('[data-ics]'))) {
      track('ics');
      var blob = new Blob([ics()], { type: 'text/calendar;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = (title.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase() || 'farmers-market') + '-' + ymd(picked) + '.ics';
      a.hidden = true;
      panel.appendChild(a);                          // inside the panel, so the outside-click handler doesn't close it
      a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    }
  });
  if (pick) pick.addEventListener('change', function () {
    var p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(pick.value);
    setPicked(p ? new Date(Number(p[1]), Number(p[2]) - 1, Number(p[3]), 12) : null, null);
  });

  // test hook (harmless in production)
  btn.fmShare = { parseHours: parseHours, ics: function () { return picked ? ics() : ''; }, gcal: function () { return picked ? gcal() : ''; } };
})();
